// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zipcodes-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.zipcodes-header {
  margin-bottom: 30px;
}

.zipcodes-header h1 {
  color: #1f2937;
  margin-bottom: 8px;
  font-size: 2rem;
}

.zipcodes-header p {
  color: #6b7280;
  font-size: 1.1rem;
}

.zipcodes-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-align: center;
  border-left: 4px solid #3b82f6;
}

.stat-card h3 {
  font-size: 2rem;
  color: #1f2937;
  margin-bottom: 8px;
}

.stat-card p {
  color: #6b7280;
  font-size: 0.9rem;
}

.zipcodes-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
}

.search-box {
  flex: 1 1;
  max-width: 400px;
}

.search-input {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.sort-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sort-select {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
}

.sort-order-btn {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  cursor: pointer;
}

.sort-order-btn:hover {
  background: #f9fafb;
}

.zipcodes-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.zipcodes-table {
  width: 100%;
  border-collapse: collapse;
}

.zipcodes-table th {
  background: #f8fafc;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.zipcodes-table th:hover {
  background: #f1f5f9;
}

.zipcodes-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.zipcode-row:hover {
  background: #f8fafc;
}

.zipcode-cell {
  font-family: 'Courier New', monospace;
  font-weight: bold;
}

.state-cell, .city-cell {
  max-width: 150px;
}

.count-cell {
  text-align: center;
}

.total-count {
  background: #3b82f6;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: bold;
}

.status-breakdown {
  display: flex;
  gap: 8px;
}

.status-dot {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
  cursor: default;
}

.status-dot.approved {
  background: #10b981;
}

.status-dot.pending {
  background: #f59e0b;
}

.status-dot.expired {
  background: #ef4444;
}

.actions-cell {
  text-align: center;
}

.view-btn {
  background: #3b82f6;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 500;
}

.view-btn:hover {
  background: #2563eb;
}

.no-results {
  text-align: center;
  padding: 40px;
  color: #6b7280;
}

@media (max-width: 768px) {
  .zipcodes-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-box {
    max-width: none;
  }
  
  .zipcodes-stats {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .zipcodes-table {
    font-size: 0.9rem;
  }
  
  .zipcodes-table th,
  .zipcodes-table td {
    padding: 8px 12px;
  }
}

/* Add these styles to your existing Zipcodes.css */

.count-cell.approved-count .count-badge.approved {
  background: #10b981;
  color: white;
  padding: 6px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: bold;
  min-width: 30px;
  display: inline-block;
  text-align: center;
}

.count-cell.pending-count .count-badge.pending {
  background: #f59e0b;
  color: white;
  padding: 6px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: bold;
  min-width: 30px;
  display: inline-block;
  text-align: center;
}

/* Update the existing total-count style if it exists */
.total-count {
  background: #3b82f6;
  color: white;
  padding: 6px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: bold;
  min-width: 30px;
  display: inline-block;
  text-align: center;
}

/* Ensure table columns have proper spacing */
.zipcodes-table th:nth-child(4),
.zipcodes-table th:nth-child(5) {
  text-align: center;
}

.zipcodes-table td.count-cell {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Zipcodes.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,mDAAmD;;AAEnD;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".zipcodes-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.zipcodes-header {\n  margin-bottom: 30px;\n}\n\n.zipcodes-header h1 {\n  color: #1f2937;\n  margin-bottom: 8px;\n  font-size: 2rem;\n}\n\n.zipcodes-header p {\n  color: #6b7280;\n  font-size: 1.1rem;\n}\n\n.zipcodes-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  border-left: 4px solid #3b82f6;\n}\n\n.stat-card h3 {\n  font-size: 2rem;\n  color: #1f2937;\n  margin-bottom: 8px;\n}\n\n.stat-card p {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n.zipcodes-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 20px;\n}\n\n.search-box {\n  flex: 1;\n  max-width: 400px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 10px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.sort-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.sort-select {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n}\n\n.sort-order-btn {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n}\n\n.sort-order-btn:hover {\n  background: #f9fafb;\n}\n\n.zipcodes-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.zipcodes-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.zipcodes-table th {\n  background: #f8fafc;\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n  cursor: pointer;\n  user-select: none;\n}\n\n.zipcodes-table th:hover {\n  background: #f1f5f9;\n}\n\n.zipcodes-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.zipcode-row:hover {\n  background: #f8fafc;\n}\n\n.zipcode-cell {\n  font-family: 'Courier New', monospace;\n  font-weight: bold;\n}\n\n.state-cell, .city-cell {\n  max-width: 150px;\n}\n\n.count-cell {\n  text-align: center;\n}\n\n.total-count {\n  background: #3b82f6;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: bold;\n}\n\n.status-breakdown {\n  display: flex;\n  gap: 8px;\n}\n\n.status-dot {\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: white;\n  cursor: default;\n}\n\n.status-dot.approved {\n  background: #10b981;\n}\n\n.status-dot.pending {\n  background: #f59e0b;\n}\n\n.status-dot.expired {\n  background: #ef4444;\n}\n\n.actions-cell {\n  text-align: center;\n}\n\n.view-btn {\n  background: #3b82f6;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 4px;\n  text-decoration: none;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.view-btn:hover {\n  background: #2563eb;\n}\n\n.no-results {\n  text-align: center;\n  padding: 40px;\n  color: #6b7280;\n}\n\n@media (max-width: 768px) {\n  .zipcodes-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .search-box {\n    max-width: none;\n  }\n  \n  .zipcodes-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .zipcodes-table {\n    font-size: 0.9rem;\n  }\n  \n  .zipcodes-table th,\n  .zipcodes-table td {\n    padding: 8px 12px;\n  }\n}\n\n/* Add these styles to your existing Zipcodes.css */\n\n.count-cell.approved-count .count-badge.approved {\n  background: #10b981;\n  color: white;\n  padding: 6px 10px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  min-width: 30px;\n  display: inline-block;\n  text-align: center;\n}\n\n.count-cell.pending-count .count-badge.pending {\n  background: #f59e0b;\n  color: white;\n  padding: 6px 10px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  min-width: 30px;\n  display: inline-block;\n  text-align: center;\n}\n\n/* Update the existing total-count style if it exists */\n.total-count {\n  background: #3b82f6;\n  color: white;\n  padding: 6px 10px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  min-width: 30px;\n  display: inline-block;\n  text-align: center;\n}\n\n/* Ensure table columns have proper spacing */\n.zipcodes-table th:nth-child(4),\n.zipcodes-table th:nth-child(5) {\n  text-align: center;\n}\n\n.zipcodes-table td.count-cell {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
